import Vue from "vue";
import Vuex from "vuex";

import { auth } from "./auth.module";

import { setting } from "./setting.module";

import { drone } from "./drone.module";

import { survey } from "./survey.module";

import { subscription } from "./subscription.module";

import { stats } from "./stats.module";

import { airport } from "./airport.module";

import { checklist } from "./checklist.module";

import { flightReview } from "./flightReview.module";

Vue.use(Vuex);

export const store = new Vuex.Store({
  strict: true,
  modules: {
    auth,
    setting,
    drone,
    survey,
    subscription,
    stats,
    airport,
    checklist,
    flightReview
  }
});
